import Earn from "./components/Earn";
import Invite from "./components/Invite";

const SellerIntegration = () => {
  return (
    <div className="grid h-full w-full grid-cols-12 gap-5">
      <div className="col-span-12 w-full 3xl:col-span-8">
        <Earn />
      </div>
      <div className="relative col-span-12 w-full rounded-xl border border-leadrs-stroke bg-white px-5 py-6 3xl:col-span-4">
        <div className="flex flex-col items-center text-center">
          <h2 className="mb-4 font-geist text-base font-bold text-leadrs-text">
            1 - Integrez facilement Leadrs a votre application
          </h2>
          <p className="mb-6 font-geist text-sm text-leadrs-text-soft">
            Soyez parmi les premiers a acceder a cette fonctionnalite exclusive.
            Consultez notre documentation pour plus de details.
          </p>
          <button
            className="rounded-lg bg-leadrs-brand px-4 py-2 font-geist text-sm font-semibold text-white transition-opacity hover:opacity-80"
            onClick={() => window.open('https://speckled-move-ba3.notion.site/Documention-Leadrs-7d64d57b47ad4e56b2b33a1869db70c8', '_blank')}
          >
            Acceder a la documentation
          </button>
        </div>
      </div>
      <div className="col-span-12 w-full 3xl:col-span-4">
        <Invite />
      </div>
    </div>
  );
};

export default SellerIntegration;
